<template>
    <div>
        <part-item :title="$t('hotGames')">
            <div slot="header-right" class="refresh" @click="shuffleGames">
                {{ $t('changeGames') }}<i class="fa fa-refresh" aria-hidden="true"></i>
            </div>

            <div class="hot-games">
                <div class="hot-game" v-for="(game,index) in currentGames" v-bind:key="index">
                    <div class="top-bg" @click="openWeb(game.detail_href)" v-lazy:background-image="game.hot_game_pic_url">
                        <div class="game-qr">
                            <div class="qr-container">
                                <img class="qr" :src="game.code_pic_url"/>
                                <div class="right-desc">
                                    <p>{{ $t('gameType') }}：{{game.type}}</p>
                                    <div class="rating">
                                        <p>{{ $t('gameRating') }}：</p>
                                        <div class="stars">
                                            <i class="fa fa-star" v-for="i in 5"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-desc">
                        <h3 class="game-title">{{ game.app_name }}</h3>
                        <p class="game-desc">{{ game.big_title }}</p>
                        <div class="links">
                            <a class="link-btn" :href="game.detail_href" target="_blank">{{ $t('goToSite') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </part-item>
    </div>
</template>

<script>

    import PartItem from '../partial/PartItem.vue'
    import md5 from 'blueimp-md5'
    import globals from '../../config/global'
    export default {
        data: function () {
            return {
                allGames:[],
                currentGames: []
            }
        },
        components: {
            PartItem
        },
        methods: {
            openWeb(url){
                window.open(url)
            },
            shuffle(array) {
                let currentIndex = array.length, temporaryValue, randomIndex;
                while (0 !== currentIndex) {
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;
                    temporaryValue = array[currentIndex];
                    array[currentIndex] = array[randomIndex];
                    array[randomIndex] = temporaryValue;
                }
                return array;
            },
            shuffleGames() {
                this.currentGames = this.shuffle(this.allGames).slice(0, 3);
            },
            getData(){
                if (globals.methods.getStorageItem('hotGameData')) {
                    this.allGames = JSON.parse(globals.methods.getStorageItem('hotGameData'));
                    this.currentGames = this.allGames.slice(0, 3);
                    return
                }
                let timeStamp = Date.parse(new Date());
                let sign = md5(timeStamp)
                let that = this
                let extraParam = '&platform=2'//1英卓，2萌果
                if(globals.isTest){//测试环境会获取未审核的内容
                    extraParam += '&isTest=1'
                }
                this.$http.get(globals.enjoyUrl + 'enjoysiteapi/gethotgame?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(
                    function (response) {
                        that.allGames = response.data
                        that.currentGames = that.allGames.slice(0, 3);
                        globals.methods.setStorageItem('hotGameData',that.allGames)
                    });
            }
        },
        created() {
            this.getData();
            
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .refresh {
        font-size: 17px;
        margin-right: 15px;
        cursor: pointer;
        .fa-refresh {
            font-size: 22px;
            margin-left: 5px;
            color: $orange-color;
        }
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }

    .component-fade-enter, .component-fade-leave-active {
        opacity: 0;
    }

    .hot-games {
        height: 283px;
        @include flex-space-between;
        .hot-game {
            height: 288px;
            width: 342px;
            position: relative;
            box-shadow: 0 5px 5px 0 rgba(143, 143, 143, 0.75);
            .top-bg {
                width: 342px;
                height: 156px;
                cursor: pointer;
                &:hover {
                    .game-qr {
                        height: 156px;
                        opacity: 1;
                        transition: all .2s linear;
                    }
                }
                .game-qr {
                    transition: all .2s linear;
                    opacity: 0.5;
                    width: 342px;
                    height: 0;
                    background: rgba(255, 170, 35, 0.9);
                    position: absolute;
                    top: 0;
                    overflow: hidden;
                    .qr-container {
                        @include flex;
                        padding: 30px;
                    }
                    .qr {
                        width: 100px;
                        height: 100px;
                    }
                    .left-qr {
                        width: 100px;
                        height: 100px;
                        @include flex-grow(0);
                    }
                    .right-desc {
                        margin-left: 15px;
                        height: 106px;
                        @include flex-grow(1);
                        overflow: hidden;
                        font-size: 15px;
                        color: #fff;
                        @include flex;
                        @include dir-top;
                        @include main-center;
                        @include cross-top;
                        .rating {
                            @include flex-row-center;
                            margin: 5px 0;
                            .stars {
                                @include flex-row-center;
                            }
                        }
                    }
                }
            }
            .bottom-desc {
                height: 283px - 156px;
                padding: 15px 30px;
                box-sizing: border-box;
                overflow: hidden;
                .game-title {
                    font-size: 19px;
                    height: 25px;
                    margin-bottom: 5px;
                }
                .game-desc {
                    font-size: 14px;
                    color: #8f8c8c;
                    height: 40px;
                    overflow: hidden;
                }
                .links {
                    @include flex;
                    @include main-right;
                    @include cross-center;
                    margin-top: 7px;
                    .link-heart {
                        color: #8f8c8c;
                        cursor: pointer;
                        &:hover {
                            color: red;
                        }
                    }
                    .link-btn {
                        display: block;
                        width: 94px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border: 1px solid #b1b1b1;
                        color: #8f8c8c;
                        font-weight: bold;
                        font-size: 15px;
                        margin-left: 10px;
                        box-sizing: border-box;
                        text-decoration: none;
                        &:hover {
                            background: $lighter-orange-color;
                            color: #fff;
                            cursor: pointer;
                            border: none;
                            transition: all .2s ease-in-out;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// HotGames.vue?3fed9800